import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

interface IFieldErrorMessageProps {
  type?: string | undefined
  message?: string | undefined
  classe?: string,
}

const FieldErrorMessage = ({ type, message, classe }: IFieldErrorMessageProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      {type === 'correction' ?
        <div className={`help correction u-txt-color-error custom-doc-row invalid u-pys u-pxs u-mts ${classe}`}>
          <span className='font-600'>
            {t('validation.subscription-correction-asked')}
          </span>
          {message && <span>: {parse(message)}</span>}
        </div>
        :
        <span className={`help u-txt-color-error ${classe}`}>{parse(message ?? '')}</span>
      }
    </>
  )
};

export default FieldErrorMessage;
